import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { ToastProvider } from './components/ui'

// ToastProvider lives above <App> so any screen can call useToast() —
// OCR Pro surfaces preferred_model_dropped / honored feedback through
// it, future screens (Settings save, Family add) reuse the same API.
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ToastProvider>
      <App />
    </ToastProvider>
  </StrictMode>,
)
